const NODE_HEIGHT = 46
const TOP_PADDING = 5
const BOTTOM_PADDING = 5

const NODE_CONTENT_RENDERER_SIZES = {
  NODE_HEIGHT,
  TOP_PADDING,
  BOTTOM_PADDING,
  ROW_HEIGHT: NODE_HEIGHT + TOP_PADDING + BOTTOM_PADDING
}

export { NODE_CONTENT_RENDERER_SIZES }
